import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import { useRecoilValue } from "recoil";
import { useTranslation } from 'react-i18next';

import { configJsonState } from "../../states/configJsonState";
import { Spinner,SimpleGrid,Center,Box,Button,Text,Input,FormControl,Modal,ModalOverlay,ModalContent,ModalHeader,ModalFooter,ModalBody,ModalCloseButton,useDisclosure,useToast, Image} from '@chakra-ui/react';


type Props = {
    myWalletAddress:string,
}
export const SelectMarketplaceButton: React.FC<Props> = (props) => {
const [buttonText,setButtonText] = React.useState(`メタマスク`);
const [t, i18n] = useTranslation();
const configStatus = useRecoilValue(configJsonState);

  const SelectMarketplaceButtonRowComponent = styled.div`
     margin-top: 0px;
  `;
  const MarketplaceMesComponent = styled.div`
     margin-top: 0px;
  `;
  const SelectMarketplaceButtonComponent = styled.button`
    border: 0.5px solid rgba(239, 239, 239, 0.2);
    backdrop-filter: blur(50px);
    border-radius: 5px;
    background: linear-gradient(175.15deg, #F6F0F2 3.05%, #E89CEE 37.82%, #DAE4FF 68.31%, #B6CBFF 96.09%);
    font-weight: 700;
    font-size: 21px;
    width: 314px;
    height: 60px;
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.6);
    margin-bottom: 10px;
    transition: all 0.5s;
    background-image: url('https://nfttopshot-template.onrender.com/template-images/btn-rainbow-square-bg.png');
    color: rgba(213, 182, 237, 1);

    &:hover {
      opacity: 0.8;
      background-color: rgba(255, 255, 255, .2);
    }
  `;
  const imageStyle:React.CSSProperties={
    width:'30px'
  }

  React.useEffect(()=>{
    (async() => {
      if (!(props.myWalletAddress === ``)) {
        setButtonText(`${t('メタマスク')}(${props.myWalletAddress.substring(0,5)}...${props.myWalletAddress.slice(-3)})`);
        // setButtonText(`${t(buttonText)}`);
      }else{
        setButtonText(`${t(buttonText)}`);
      }
    })()
  },[]);

  return (
    <SelectMarketplaceButtonRowComponent>
        <MarketplaceMesComponent>
            <SelectMarketplaceButtonComponent 
              // id='mywalletbutton' 
              id="btn-default-mypage-metamask"
              type="button" 
              onClick={()=>{
                window.open(`https://tofunft.com/${configStatus.lang}/user/${props.myWalletAddress}/items/in-wallet`);
              }}
            >
              <Image
                  w={'30px'}
                  src="https://nfttopshot-template.onrender.com/template-images/metamask.png"
                  display={'inline-block'}
                  mt={'-5px'}
                  mr={'7px'}
                />
                <Text
                  display={'inline-block'}
                  fontSize={'19px'}
                  mb={`0px`}
                  fontWeight={'bold'}
                  color={'orange.300'}
                >
                {buttonText}
                </Text>
            </SelectMarketplaceButtonComponent>
        </MarketplaceMesComponent>
    </SelectMarketplaceButtonRowComponent>
  );
};